import clsx from 'clsx'
import * as React from 'react'

import { ReactComponent as AccordionMinusIcon } from '../../../Assets/accordionMinus.svg'
import { ReactComponent as AccordionPlusIcon } from '../../../Assets/accordionPlus.svg'
import Headings from '../../atoms/Heading'
import Paragraph from '../../atoms/Paragraph'
import Contents from './Contents'
import './style.css'

interface Props {
  content?: any
  headline?: string
  subheadline?: string
  description?: string
}

/**
 * Accordion Component
 * @param content - Content from the CMS.
 */

const Accordion = ({ content }: Props) => {
  const toggleQuickLinks = (e: any) => {
    e.stopPropagation()
    const parentEle = e.target.closest('.list')
    parentEle.classList.toggle('active')
  }

  const stackedLayOut = content?.layoutStyle === 'Stacked (heading and intro above, accordion below)'

  return (
    <>
      <div
        data-testid="accordion"
        className={`layoutSpacing ${content.sectionBackgroundColor !== 'bg-white' ? 'sectionSpacing sectionBottomMargin' : 'sectionBottomSpacing'} ${
          content.backgroundColour === 'Light purple' ? 'bg-purple-50' : 'bg-white'
        }`}
      >
        <div className={clsx(!stackedLayOut && 'xl:flex', 'layout w-100 gap-24')} aria-labelledby="accordion section">
          <div className={clsx(!stackedLayOut && 'xl-pb-0 w-full pb-24 md:w-75 xl:w-33', 'w-full')}>
            {content?.sectionHeading && (
              <Headings content={content?.sectionHeading} variant="H2" classes="text-purple-100" />
            )}
            {content?.sectionDescription && <Paragraph content={content?.sectionDescription} classes="pb-16" />}
          </div>
          <div
            className={clsx(
              'accordion w-full self-start rounded-2xl border border-neutral-50',
              content.backgroundColour === 'Light purple' ? 'bg-white' : 'bg-purple-50',
              !stackedLayOut && '2xl:4/5 xl:w-2/3',
            )}
          >
            {content.accordions.map((item, index) => {
              return (
                <div key={`accordion-${index}`} className="list border-b border-neutral-50 last:border-none">
                  <div
                    className="title flex cursor-pointer items-center justify-between p-32"
                    onClick={(e) => {
                      toggleQuickLinks(e)
                    }}
                    role="button"
                    tabIndex={0}
                    aria-label="Toggle accordion section content"
                  >
                    <Headings
                      content={item.fields.accordionHeading}
                      variant="H4"
                      classes="text-purple-100 pr-12 !pb-0 max-w-[85%] flex-1 break-words"
                    />
                    <AccordionPlusIcon className='accordionPlus flex-none'/>
                    <AccordionMinusIcon className='accordionMinus flex-none'/>
                  </div>
                  <div data-testid="accordionContaner" className={`content w-100`}>
                    {item.fields?.content && (
                      <Contents
                        content={item.fields?.content}
                        image={item.fields?.accordionImage}
                        position={item.fields?.imagePosition}
                        stackedLayOut={stackedLayOut}
                      />
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}

export default Accordion
